import ErrorPage from "error/components";
import { connect } from "react-redux";
import { withRouter } from "react-router";

export function mapStateToProps({ error }) {
  return { error };
}

export default withRouter(connect(mapStateToProps)(ErrorPage));
